var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "136 -635.08 688 310.16",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.62-324.92H291.08q-64.36 0-109.72-45.42Q136-415.75 136-480.18q0-64.44 45.36-109.67t109.72-45.23h125.54v32H291.08q-50.77 0-86.93 36.16Q168-530.77 168-480t36.15 86.92q36.16 36.16 86.93 36.16h125.54zM356-464v-32h248v32zm187.38 139.08v-32h125.54q50.77 0 86.93-36.16Q792-429.23 792-480t-36.15-86.92q-36.16-36.16-86.93-36.16H543.38v-32h125.54q64.36 0 109.72 45.42Q824-544.25 824-479.82q0 64.44-45.36 109.67t-109.72 45.23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.bec011dea3d2c29f29b2ba66063b54c0.svg";
export { ForwardRef as ReactComponent };